
import React from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface MobileCategoriesProps {
  preachingImageUrl: string;
  passionsImageUrl: string;
}

const MobileCategories = ({ preachingImageUrl, passionsImageUrl }: MobileCategoriesProps) => {
  const navigate = useNavigate();
  
  const handleNavigate = (path: string) => {
    console.log("Mobile categories navigating to:", path);
    navigate(path);
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      {/* First section - Leidenschaften */}
      <div className="space-y-2">
        <h4 className="text-base md:text-lg font-bold text-white text-center uppercase mb-3">
          MEINE LEIDENSCHAFTEN & HOBBIES
        </h4>
        <button 
          onClick={() => handleNavigate('/kurzueberblick')}
          className="group w-full relative rounded-lg overflow-hidden border border-white/20 transition-transform hover:scale-[1.02] h-[120px] md:h-[140px]"
        >
          <div className="aspect-video w-full h-full">
            <img
              src={passionsImageUrl}
              alt="Meine Leidenschaften & Hobbies"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors">
              <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center animate-horizontal-bounce">
                <ChevronRight className="w-4 h-4 text-white" />
                <ChevronRight className="w-4 h-4 text-white -ml-2" />
              </div>
            </div>
          </div>
        </button>
      </div>
      
      {/* Second section - Predigt */}
      <div className="space-y-2">
        <h4 className="text-base md:text-lg font-bold text-white text-center uppercase mb-3">
          PREDIGT & POETRY SLAM
        </h4>
        <button 
          onClick={() => handleNavigate('/preaching')}
          className="group w-full relative rounded-lg overflow-hidden border border-white/20 transition-transform hover:scale-[1.02] h-[120px] md:h-[140px]"
        >
          <div className="aspect-video w-full h-full">
            <img
              src={preachingImageUrl}
              alt="Predigt & Poetry Slam"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors">
              <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center animate-horizontal-bounce">
                <ChevronRight className="w-4 h-4 text-white" />
                <ChevronRight className="w-4 h-4 text-white -ml-2" />
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default MobileCategories;
